import React from "react";
import { PublicBlogContentInner, SkeletonCard } from "./PublicBlog.styles";

const PublicBlogSkeleton = () => (
  <PublicBlogContentInner aria-hidden="true">
    <SkeletonCard />
    <SkeletonCard />
    <SkeletonCard />
    <SkeletonCard />
  </PublicBlogContentInner>
);

export default PublicBlogSkeleton;
